import { Component, afterNextRender } from '@angular/core';
import { RouterOutlet } from '@angular/router';

const SPLASH_MIN_DURATION = 2000;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  constructor() {
    const bootTime = performance.now();

    afterNextRender(() => {
      const elapsed = performance.now() - bootTime;
      const remaining = Math.max(0, SPLASH_MIN_DURATION - elapsed);

      setTimeout(() => this.dismissSplash(), remaining);
    });
  }

  private dismissSplash(): void {
    const splash = document.getElementById('pmdf-splash-screen');
    if (!splash) return;

    splash.style.transition = 'opacity 0.4s ease-out';
    splash.style.opacity = '0';
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
  }
}
